var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "configured-layout",
    {
      attrs: {
        title: "Select Options",
        breadcrumbs: _vm.breadcrumbs,
        disabled: _vm.loading
      },
      on: { next: _vm.onNext }
    },
    [
      _vm.headerItems
        ? _c(
            "b-tabs",
            {
              staticClass: "option-tabs",
              model: {
                value: _vm.optionsTabIndex,
                callback: function($$v) {
                  _vm.optionsTabIndex = $$v
                },
                expression: "optionsTabIndex"
              }
            },
            _vm._l(_vm.headerItems, function(options, title) {
              return _c(
                "b-tab",
                { key: title, attrs: { title: title } },
                [_c("options-list", { attrs: { options: options } })],
                1
              )
            }),
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }